import React from 'react'

export const ClockIconV2 = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_17385_126056)'>
        <path
          d='M12 8V12L15 15'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.55989 3.69043C7.46797 4.14242 6.47576 4.80502 5.63989 5.64043'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M3.69 8.55957C3.23656 9.64987 3.0021 10.8187 3 11.9996'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M3.68994 15.4404C4.14193 16.5323 4.80454 17.5246 5.63994 18.3604'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.56006 20.3096C9.65036 20.763 10.8192 20.9975 12.0001 20.9996'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15.4399 20.3104C16.5319 19.8584 17.5241 19.1958 18.3599 18.3604'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M20.3101 15.44C20.7635 14.3497 20.998 13.1808 21.0001 12'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M20.3101 8.55965C19.8581 7.46773 19.1955 6.47552 18.3601 5.63965'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15.44 3.69C14.3497 3.23656 13.1808 3.0021 12 3'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_17385_126056'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
